export const INPUT_PATTERNS = Object.freeze({
  decimal: "[0-9]*\\.?[0-9]*",
  integer: "[0-9]*",
  placeName: "[A-Za-z '-]*",
})

export function digitsOnly(value) {
  return value.replace(/\D/g, "")
}

export function decimalOnly(value) {
  const sanitized = value.replace(/[^\d.]/g, "")
  const [whole, ...decimalParts] = sanitized.split(".")
  if (!decimalParts.length) return whole

  const decimal = decimalParts.join("")
  if (!whole && !decimal) return ""

  return `${whole}.${decimal}`
}

export function placeNameOnly(value) {
  return value.replace(/[^A-Za-z\s'-]/g, "")
}
